module.exports = __webpack_public_path__ + "static/img/preview-bg-top.bb7b2aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview-bg-top.png
// module id = bNre
// module chunks = 1